"use strict";
/*
author:fanglijuan
date:2017-07-17
 */
angular.module("planCommandMonitorRegionalHotspotsModule", [
        'planCommandMonitorRegionalHotspotsRelateArticleModule',
        "planCommandRegionalHotspotsRouterModule",
        'regionalHotspotsNavModule',
        'planCommandMonitorRegionalHotFeatureListModule',
        'planCommandMonitorCustomHotspotContentMgrModule',
        'planCommandMonitorZjHotspotContentMgrModule',
        'planCommandMonitorCountryHotspotContentMgrModule',
        'planCommandMonitorInterHotspotContentMgrModule',
    ])
    .controller("planCommandMonitorRegionalHotspotsCtrl", ["$scope", "$location", function($scope, $location) {
        
    }]);
